import http from '../../../Utils/http';

const GetAllDsoDisplaysWithZones = {
  name: 'displaysWithZones',
  state: {
    data: [],
    loading: false,
    error: '',
    totalCount: 0,
  },
  reducers: {
    getReceived(state, payload) {
      return {
        ...state,
        data: [...state.data, ...payload.data],
        loading: false,
        error: '',
        totalCount: payload.totalCount,
      };
    },
    resetData(state) {
      return {
        ...state,
        data: [],
      };
    },
  },
  effects: (dispatch) => ({
    async recursion(arr) {
      if (arr.length === 0) {
        return;
      }
      const id = arr.pop();
      let url = `savvy/displays/${id.id}?page=1&size=1000`;
      const response = await http.get(`${url}`);
      this.getReceived({
        data: response.data.data,
      });
      this.recursion(arr);
    },
    async getData(data) {
      this.resetData();
      this.recursion(data);
    },
  }),
};

export default GetAllDsoDisplaysWithZones;
